import React from 'react';
import clientInformation, { getClientItem } from '../login/ClientInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, CheckCustomerData } from "../../services/AuthenticationService";
import { useParams } from 'react-router-dom';
import { onlyNumbers, BonusString } from '../helpers/common';
import { EWalletDeposit, SendOtpR4conecta } from "../../services/DepositService";
import Bonus from '../Bonus';
import { isMobile } from 'react-device-detect';
import { MissingAccountInfo } from "../deposit/MissingAccountInfo.jsx";
import iframeResizer from 'iframe-resizer';
import swal from 'sweetalert2';

export const R4DebitoInmediato = () => {
    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    let INSTANCEID = clientInfo.InstanceID;
    let url = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    const { id } = useParams();
    const [arrayRegularDeposits, setRegularDeposits] = useState(JSON.parse(getClientItem('ArrayRegularMethods')).filter(function (element) { return element.DepositID == id; })[0]);
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [showiFrame, setshowiFrame] = useState(false);
    const [showFrameTitle, setShowFrameTitle] = useState(true);
    const [showForm, setshowForm] = useState(true);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [arrayEwallet, setArrayEwallet] = useState([]);
    const [isValidate, setIsValidate] = useState(true);
    const [isSecureIdVisible, setIsSecureIdVisible] = useState(false);
    const [isAccountVisible, setIsAccountVisible] = useState(false);
    const [height, setHeight] = useState('500px');
    const iframeRef = React.useRef(null);
    const lastHeightRef = React.useRef(0);
    const debounceTimeout = React.useRef(null);
    const [shouldScroll, setShouldScroll] = useState(false);
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');
    const [showR4conecta, setshowR4conecta] = useState(false);
    const [r4OtpSent, setR4OtpSent] = useState(false);

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(function (response) {
            validateFields();
            doCheckCustomerData();

        })
            .catch(function (error) {
                navigate('/expired/');
            })
        if (arrayRegularDeposits == undefined) {
            navigate('/deposits/');
        }

        // Funci�n para copiar el n�mero de referencia
        window.copyReferenceNumber = function (refNum) {
            navigator.clipboard.writeText(refNum).then(() => {
                const feedbackDiv = document.getElementById('copyFeedback');
                if (feedbackDiv) {
                    feedbackDiv.style.display = 'inline';
                    feedbackDiv.style.color = 'green';
                    feedbackDiv.textContent = 'Copied!';

                    setTimeout(() => {
                        feedbackDiv.style.display = 'none';
                    }, 2000);
                }
            });
        }
        const handleMessage = (event) => {
            // Optional: Validate origin
            // if (event.origin !== 'https://trusted-site.com') return;

            const data = event.data;
            if (data && data['full-content-height']) {
                setShowFrameTitle(false);
                const newHeight = parseInt(data['full-content-height'], 10);

                // Clamp to reasonable range (e.g., 300px to 900px)
                if (newHeight < 300 || newHeight > 900) return;

                // Debounce to avoid rapid resizing
                if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current);
                }

                debounceTimeout.current = setTimeout(() => {
                    // Only update if height actually changed
                    if (newHeight !== lastHeightRef.current) {
                        lastHeightRef.current = newHeight;
                        setHeight(`${newHeight}px`);
                    }
                }, 300);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };



    }, [])


    function handleResponseFromComponent(response) {
        setIsValidate(response);
    }

    async function validateFields() {
        switch (arrayRegularDeposits.ImageName.toLowerCase()) {
            case "paysafecard":
            case "bitcoin":
            case "marketusa":
            case "wipay":
            case "changelly":
            case "wallet88":
            case "quickbuy":
            case "flashteller":
            case "triplewallet":
            case "majestic":
            case "applepay":
            case "googlepay":
            case "cashapp":
            case "paypal":
            case "venmo":
            case "zelle":
            case "moonpay":
            case "alphapaysonramp":
            case "tylt":
            case "paycash":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('700px');
                }
                break;
            case "wallet88emt":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('700px');
                }
                break;
            case "quickervoucherv2":
            case "kribatta":

                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('900px');
                }
                break;
            case "fastgateway":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('550px');
                    setShouldScroll(true);
                }
                break;
            case "r4debitoinmediato":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('700px');
                    setshowR4conecta(true);
                }
                break;
            default:
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(true);
                }
                break;
        }
    }

    async function doCheckCustomerData() {
        await CheckCustomerData(getClientItem('Token'), arrayRegularDeposits.DepositID).then(async function (response) {
            if (!response.Authentication.AllComplete) {
                setIsValidate(true);
            }
            else {
                setIsValidate(false);
            }
        })
    };

    if (isValidate) {
        return <MissingAccountInfo Processor={arrayRegularDeposits.DepositID} isValidate={handleResponseFromComponent.bind(isValidate)} />;
    }

    /*async function doSendOtpR4conecta(Amount, Banco) {

        setIsProcessing(true);
        try {
            const response = await SendOtpR4conecta(
                getClientItem('Token'),
                Amount,
                arrayRegularDeposits.DepositName,
                Banco
            );

            if (response?.Authentication?.Code === "202" || response?.Authentication?.Code === 202) {
                setR4OtpSent(true);
                Alerts.ShowAlert('OTP Enviado', 'El OTP ha sido enviado al telefono registrado en el sistema. Por favor ingrese el OTP en el campo que corresponde para finalizar el proceso.', 'success');
            } else {
                Alerts.ShowAlert('Error', response?.Authentication?.ErrorDescription ?? 'No fue posible enviar el OTP. Por favor, intente nuevamente.', 'error');
            }
        } catch (error) {
            if (isMobile) {
                Alerts.ShowAlertFullScreen('Error', 'No fue posible enviar el OTP', 'error');
            } else {
                Alerts.ShowAlert('Error', 'No fue posible enviar el OTP', 'error');
            }
        } finally {
            setIsProcessing(false);
        }
    }*/
    async function doSendOtpR4conecta(Amount, Banco) {
        setIsProcessing(true);
        try {
            const response = await SendOtpR4conecta(
                getClientItem('Token'),
                Amount,
                arrayRegularDeposits.DepositName,
                Banco
            );

            if (response?.Authentication?.Code === "202" || response?.Authentication?.Code === 202) {

                const { value: otp, isConfirmed } = await swal.fire({
                    title: 'OTP Enviado',
                    html: `
                    <p style="margin-bottom: 16px">El OTP ha sido enviado al tel&eacute;fono registrado en el sistema.</p>
                    <input id="swal-otp" type="text" class="swal2-input" 
                        placeholder="Ingrese el OTP" 
                        maxlength="8"
                        inputmode="numeric"
                        autocomplete="one-time-code"
                        style=" font-size: 20px; font-weight: bold; text-align: center;" />
                `,
                    icon: 'success',
                    confirmButtonText: 'Realizar Dep&oacute;sito',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    preConfirm: () => {
                        const otpValue = document.getElementById('swal-otp').value.trim();
                        if (!otpValue) {
                            swal.showValidationMessage('Por favor ingrese el OTP');
                            return false;
                        }
                        return otpValue;
                    }
                });

                if (isConfirmed && otp) {
                    setIsProcessing(true);
                    await doEWalletDeposit(Amount, '', otp);
                    setIsProcessing(false);
                }

            } else {
                Alerts.ShowAlert('Error', response?.Authentication?.ErrorDescription ?? 'No fue posible enviar el OTP. Por favor, intente nuevamente.', 'error');
            }
        } catch (error) {
            if (isMobile) {
                Alerts.ShowAlertFullScreen('Error', 'No fue posible enviar el OTP', 'error');
            } else {
                Alerts.ShowAlert('Error', 'No fue posible enviar el OTP', 'error');
            }
        } finally {
            setIsProcessing(false);
        }
    }

    async function doEWalletDeposit(Amount, Account, SecureID) {
        console.log(Amount);
        var Data =
        {
            "Token": getClientItem('Token'),
            "eWalletAccount": Account,
            "eWalletPassword": SecureID,
            "ProcessorName": arrayRegularDeposits.DepositName,
            "InstanceID": INSTANCEID,
            "Amount": Amount,
            "CurrencyCode": "VES",
            "returnURL": "",
            "statusURL": "",
            "TransactionID": "-1",
            "IPv4Address": clientInfo.IPAddress,
            "BonusList": BonusString(JSON.parse(getClientItem('ArrayBonus')))
        };
        
        await EWalletDeposit(Data).then(function (response) {

            setArrayEwallet(response.Authentication);

            if (response.Authentication.ErrorCode != undefined && response.Authentication.ErrorCode != null) {

                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error with eWallet Deposit', response.Authentication.ErrorDescription, 'error');
                }
                else {
                    Alerts.ShowAlert('Error with eWallet Deposit', response.Authentication.ErrorDescription, 'error');
                }

            }
            else {
                var message = response.Authentication.HtmlResponse;
                if (response.Authentication.status == "PENDING") {
                    var Link = response.Authentication.Descriptor;
                    if (Link != "" && Link != undefined && URL.canParse(Link)) {
                        if (arrayRegularDeposits.ImageName.toLowerCase() == 'alphapaysonramp') {
                            window.open(Link, "_blank");
                        }
                        else {
                            setshowiFrame(true);
                            setshowForm(false);
                            forceUpdate();
                        }
                    }
                    else {
                        if (arrayRegularDeposits.ImageName.toLowerCase() == 'premierint' ||
                            arrayRegularDeposits.ImageName.toLowerCase() == 'premieret' ||
                            arrayRegularDeposits.ImageName.toLowerCase() == 'triplewallet' ||
                            arrayRegularDeposits.ImageName.toLowerCase() == 'premierplus') {
                            message += response.Authentication.Descriptor;

                            if (isMobile) {
                                Alerts.ShowAlertFullScreen('Deposit Pending', message, 'info');
                            }
                            else {
                                Alerts.ShowAlert('Deposit Pending', message, 'info');
                            }
                        }
                        if (arrayRegularDeposits.ImageName.toLowerCase() == 'paycash') {
                            //message = "Your Paycash reference number is: " + response.Authentication.Descriptor + "<br><br>Once the deposit is completed, your balance will be updated."; 
                            message = "Your Paycash reference number is:<br><div style='display: flex; align-items: center; justify-content: center; gap: 10px; margin: 15px 0;'><span id='refNumber' style='font-size: 22px; font-weight: bold; color: #333;'>" + response.Authentication.Descriptor + "</span><button onclick=\"copyReferenceNumber('" + response.Authentication.Descriptor + "')\" style='background: none; border: none; cursor: pointer; font-size: 18px; padding: 5px; color: #007bff;' title='Copy to clipboard'><i class='fas fa-copy'></i></button><span id='copyFeedback' style='display: none; font-size: 14px; margin-left: 10px;'></span></div>Once the deposit is completed, your balance will be updated.";
                            if (isMobile) {
                                Alerts.ShowAlertFullScreen('Deposit Pending', message, 'info');
                            }
                            else {
                                Alerts.ShowAlert('Deposit Pending', message, 'info');
                            }
                        }
                        else {
                            message += "<br/><br/><div class='bitcoinaddress'>Address: <b>" + response.Authentication.Descriptor + "</b></div>";
                            if (response.Authentication.Notes !== 'undefined' && response.Authentication.Notes != '')
                                message += "<br/><br/><div class='bitcoinaddress'>Please deposit the following btc amount:<br/> <b>" + response.Authentication.Notes + "</b></div>";

                            if (isMobile) {
                                Alerts.ShowAlertFullScreen('eWallet Deposit Completed', message, 'info');
                            }
                            else {
                                Alerts.ShowAlert('eWallet Deposit Completed', message, 'info');
                            }

                        }
                    }
                }
                else if (response.Authentication.status == "REJECTED") {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('eWallet Deposit Rejected', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('eWallet Deposit Rejected', message, 'info');
                    }

                }
                else {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('eWallet Deposit Completed', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('eWallet Deposit Completed', message, 'info');
                    }
                }

            }

        })
            .catch(function (error) {
                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error', 'Error making deposit', 'error');
                }
                else {
                    Alerts.ShowAlert('Error', 'Error making deposit', 'error');
                }

            })


    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (isProcessing) return;

        var data = new FormData(event.target);
        let { amount, accountoremail, secureid, otp, banco } = Object.fromEntries(data.entries());

        if (!amount) {
            Alerts.ShowAlert('Warning', 'Monto requerido', 'warning');
            return;
        }
        if (!banco) {
            Alerts.ShowAlert('Warning', 'Banco requerido', 'warning');
            return;
        }

        await doSendOtpR4conecta(amount, banco);

        return;
    }

    const handleIframeLoad = () => {
        setShowFrameTitle(false);
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px", }} src={"/svg/" + arrayRegularDeposits.ImageName + ".svg"} /> <span> D&eacute;bito Inmediato </span>
                    </span>
                </div>
                {
                    id.toLowerCase() == "ph-paypal" && <div className="row m-1">
                        <div className="alert alert-primary text-center" role="alert">
                            To use PayPal as a deposit method, customers must first ensure that funds are available in their PayPal account. <b>Add money to your PayPal balance</b> before attempting to make a deposit.
                        </div>
                    </div>
                }
                {
                    id.toLowerCase() == "ph-applepay" && <div className="row m-1">
                        <div className="alert alert-primary text-center" role="alert">
                            To successfully use Google Pay or Apple Pay for deposits, the <b>billing address on your Apple/Google Pay account must match the address listed </b> on your customer account.
                            Please verify this information before proceeding with a deposit.
                        </div>
                    </div>
                }
                {
                    id.toLowerCase() == "ph-moonpay" && <div className="row m-1">
                        <div className="alert alert-primary text-left" role="alert">
                            Before using MoonPay for deposits, customers are required to complete a one-time KYC (Know Your Customer) verification process. This process includes:
                           <ul class="m-1">
                                <li>Uploading a valid picture ID</li>
                                <li>Completing a biometric scan</li>
                                <li>Providing your Social Security Number (SSN) For US customers only</li>
                            </ul>
                        </div>
                    </div>
                }
                {showForm && <div >
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="row">
                                {isSecureIdVisible && <div className="col-md-12 clear row-12" >
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label for="secureid" className="col-md-offset-3 col-md-2  col-sm-offset-3 col-sm-2 col-xs-12">SecureID:</label>
                                        <div className="col-md-7 col-sm-7 col-xs-12">
                                            <input type="password" className="form-control" name="secureid"
                                                aria-label="secure id" placeholder="SecureID" required />
                                        </div>
                                    </div>
                                </div>}
                                {isAccountVisible && <div className="col-md-12 clear row-12 mb-4">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label for="secureid" className="col-md-offset-3 col-md-2  col-sm-offset-3 col-sm-2 col-xs-12">Account:</label>
                                        <div className="col-md-7 col-sm-7 col-xs-12">
                                            <input type="text" className="form-control" name="accountoremail"
                                                aria-label="account or email" placeholder="Account" required />
                                        </div>
                                    </div>
                                </div>}
                                <div >
                                    <div className="row">
                                        <div className="col-md-2">&nbsp;</div>
                                        <div className="col-md-12 col-sm-12 col-xs-12 mb-3">
                                            <div className="input-group">
                                                <div className="alert alert-primary" role="alert" style={{ width: "100%" }}>
                                                    <p>
                                                        Para realizar un d&eacute;bito inmediato, debes ingresar el monto y el n&uacute;mero de banco, con esto debes generar el OTP el cual ser&aacute; enviado
                                                        al siguiente numero de t&eacute;lefono: <strong>{getClientItem('Phone')}</strong> <br />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2">&nbsp;</div>
                                    </div>

                                </div>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <div className="row align-items-start">

                                        {/* Amount */}
                                        <div className="col-md-4 col-sm-6 col-xs-12">
                                            <label htmlFor="amount">Monto:</label>
                                            <div className="input-group mb-1">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                                        <select className="form-control selectcurrency" readOnly name="CurrencyCode" required value={clientInfo.CurrencyCode == 'mBTC' ? 'USD' : clientInfo.CurrencyCode}>                                                            
                                                            <option selected value="VES">Bs</option>
                                                        </select>
                                                    </span>
                                                </div>                                                
                                                <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Ingrese el monto" max={arrayRegularDeposits?.MaxDeposit === 0 ? MAXLIMIT : arrayRegularDeposits?.MaxDeposit} min={arrayRegularDeposits?.MinDeposit === 0 ? 1 : arrayRegularDeposits?.MinDeposit} name="amount" required="" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0} />
                                            </div>
                                            <div className="d-flex flex-row ml-2 limit-text-center mb-4">
                                                Deposit Limits: Minimum {arrayRegularDeposits.MinDeposit == 0 ? 1 : arrayRegularDeposits.MinDeposit} USD Maximum {arrayRegularDeposits.MaxDeposit == 0 ? 'No Limit' : arrayRegularDeposits.MaxDeposit + ' USD'}
                                            </div>
                                        </div>

                                        {/* Banco */}
                                        <div className="col-md-4 col-sm-6 col-xs-12">
                                            <label htmlFor="banco">Banco:</label>
                                            <input type="text" className="form-control mb-4" name="banco" required=""
                                                aria-label="Banco" placeholder="Ingrese el Banco" autoComplete="off" />
                                        </div>

                                    </div>
                                </div>

                                <Bonus ProcessorName={id} />
                            </div>
                        </div>

                    </div>

                </div>}
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/deposits/')}>BACK</button>
                        {!showiFrame && (
                            <button type="submit"
                                className="btn btn-deposit btn-deposit-order mb-4 submit"
                                disabled={isProcessing}>
                                {isProcessing ? "Processing..." : "GENERAR OTP"}
                            </button>
                        )}
                    </div>
                </div>
            </form >
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>

    );
}